import { render, staticRenderFns } from "./SavedSearch.vue?vue&type=template&id=60e19d93&scoped=true&"
import script from "./SavedSearch.vue?vue&type=script&lang=js&"
export * from "./SavedSearch.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearch.vue?vue&type=style&index=0&id=60e19d93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e19d93",
  null
  
)

export default component.exports